import React, { useState, useEffect } from 'react';
import Select, {Props, createFilter } from 'react-select';

const ReactSelect: React.FC<Props> = (props:Props) => {
	// There's a bug in react-select that causes it to crash when server-side rendering, which happens
	// when the magic box attempts to create an example from a story.  The bug is rooted in WP using
	// React 18, but because of our magic box, it degrades to React 17, which is incompatible with
	// some react-dom code that react-select uses.  This caused the editor to crash.  This workaround
	// prevents the <Select/> from rendering until the component is mounted, which bypasses the issue.
	// This is relevant only if the component has the @block decorator, but I'm encapsulating the logic
    // here and using it throughout for future-proofing.
	const [ renderSelect, setRenderSelect ] = useState(false);
	useEffect( () => {
		setRenderSelect(true);
	}, []);
    return renderSelect ? <Select {...props} /> : null;
}

export { createFilter };
export default ReactSelect;